import Action from '../action';

export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const SEARCH_INITIATED = 'SEARCH_INITIATED';
export const SEARCH_REQUESTED = 'SEARCH_REQUESTED';
export const SEARCH_UPDATED = 'SEARCH_UPDATED';
export const UPDATE_SEARCH_PREREQUISITES = '@search/UPDATE_SEARCH_PREREQUISITES';
export const SEARCH_REFRESH = '@search/SEARCH_REFRESH';
export const SEARCH_RESET = 'SEARCH_RESET';
export const SEARCH_BEGIN = 'SEARCH_BEGIN';
export const SEARCH_EXPORT = 'SEARCH_EXPORT';
export const SEARCH_EXPORT_FAILURE = 'SEARCH_EXPORT_FAILURE';
export const SEARCH_EXPORT_SUCCESS = 'SEARCH_EXPORT_SUCCESS';

export const FACET_SELECTED = 'FACET_SELECTED';
export const FACET_SELECTED_EXCLUSIVE = 'FACET_SELECTED_EXCLUSIVE';
export const FACET_DESELECTED = 'FACET_DESELECTED';
export const FACET_DESELECTED_EXCLUSIVE = 'FACET_DESELECTED_EXCLUSIVE';
export const SET_SELECTED_FACETS = 'SET_SELECTED_FACETS';

export const SET_SELECTED_TAG_FILTERS = 'SET_SELECTED_TAG_FILTERS';
export const TAG_FILTERS_UPDATED = 'TAG_FILTERS_UPDATED';

export const TAG_FILTER_ADDED = 'TAG_FILTER_ADDED';
export const TAG_FILTER_REMOVED = 'TAG_FILTER_REMOVED';

export const QUERY_ADDED = 'QUERY_ADDED';
export const QUERY_REMOVED = 'QUERY_REMOVED';

export const ACCOUNT_ADDED = 'ACCOUNT_ADDED';
export const ACCOUNT_REMOVED = 'ACCOUNT_REMOVED';

export const SORT_UPDATED = 'SORT_UPDATED';
export const LAST_SEEN_UPDATED = 'LAST_SEEN_UPDATED';

export const ALERTS_FACET_TYPE = 'alerts';
export const SECURITY_GROUPS_FACET_TYPE = 'securityGroups';
export const MAINTENANCE_STATUS_FACET_TYPE = 'maintenance';
export const COMMUNICATED_AT_FACET_TYPE = 'lastCommunicated';
export const LAST_SEEN_FACET_TYPE = 'lastSeen';

export const initiated = search => Action(SEARCH_INITIATED, search);
export const updated = () => Action(SEARCH_UPDATED);
export const refresh = () => Action(SEARCH_REFRESH);
export const requested = () => Action(SEARCH_REQUESTED);
export const updatePrerequisites = prerequisites => Action(UPDATE_SEARCH_PREREQUISITES, prerequisites);

export const searchSuccess = payload => Action(SEARCH_SUCCESS, payload);
export const searchFailure = error => Action(SEARCH_FAILURE, error, true);
export const searchExport = () => Action(SEARCH_EXPORT);
export const searchExportFailure = () => Action(SEARCH_EXPORT_FAILURE);
export const searchExportSuccess = () => Action(SEARCH_EXPORT_SUCCESS);
export const resetSearch = () => Action(SEARCH_RESET);
export const updateSort = name => Action(SORT_UPDATED, name);
export const addQuery = term => Action(QUERY_ADDED, term);
export const updateLastSeen = lastSeen => Action(LAST_SEEN_UPDATED, lastSeen);

export const removeQuery = term => Action(QUERY_REMOVED, term);
export const selectFacet = (facetType, value) =>
  Action(FACET_SELECTED, {
    facetType,
    value
  });

export const deselectFacet = (facetType, value) =>
  Action(FACET_DESELECTED, {
    facetType,
    value
  });

export const updateTagFilters = filters => Action(TAG_FILTERS_UPDATED, filters);
export const addTAGFilter = tagFilter => Action(TAG_FILTER_ADDED, tagFilter);
export const removeTAGFilter = tagFilter => Action(TAG_FILTER_REMOVED, tagFilter);
export const exclusiveDeselectFacet = (facetType, value = {id: null}) =>
  Action(FACET_DESELECTED_EXCLUSIVE, {
    facetType,
    value
  });

export const exclusiveSelectFacet = (facetType, value) =>
  Action(FACET_SELECTED_EXCLUSIVE, {
    facetType,
    value
  });

export const addAccount = account => Action(ACCOUNT_ADDED, account);
export const removeAccount = account => Action(ACCOUNT_REMOVED, account);
